import React from 'react';
import { DeviceUnlockComponent } from '@/store/sagas/types/deviceUnlock';
import { log } from '@/lib/utils/logger';
import DeviceStatusCheckRenderer from './DeviceStatusCheckRenderer';
import FAQRenderer from './FAQRenderer';
import ConfirmationRenderer from './ConfirmationRenderer';
import StatusDisplayRenderer from './StatusDisplayRenderer';
import GlobalFooterRenderer from './GlobalFooterRenderer';
import HeroRenderer from './HeroRenderer';
import PageWrapperRenderer from './PageWrapperRenderer';
import DeviceStatusRenderer from './DeviceStatusRenderer';
interface ComponentRendererProps {
  component: DeviceUnlockComponent;
  onSubmit?: (data: Record<string, unknown>) => void;
  onNavigate?: (destination: string) => void;
  isRecaptchaReady?: boolean;
  isRecaptchaEnabled?: boolean;
  isSlowNetwork?: boolean;
}
// Main Component Renderer
export const ComponentRenderer: React.FC<ComponentRendererProps> = ({ component, onSubmit, onNavigate, isRecaptchaReady = false, isRecaptchaEnabled = true, isSlowNetwork = false }) => {
  // Handle null or undefined components
  if (!component) {
    log.warn('ComponentRenderer: component is null or undefined');
    return null;
  }

  log.debug('ComponentRenderer rendering component type:', component.type);

  // Normalize component type - map lowercase/snake_case to uppercase
  const normalizedType = component.type?.toUpperCase().replace(/_/g, '_') || '';
  const componentType = (() => {
    if (normalizedType.includes('ID_DEVICESTATUS') || normalizedType === 'ID_DEVICESTATUS') {
      return 'DEVICE_STATUS';
    }
    if (normalizedType.includes('DEVICESTATUS')) {
      return 'DEVICE_STATUS';
    }
    return normalizedType;
  })();

  console.log('[DEBUG] Normalized component type:', componentType);

  switch (componentType) {
    case 'GLOBAL_FOOTER':
      console.log('[DEBUG] Rendering GLOBAL_FOOTER');
      return <GlobalFooterRenderer component={component} />;
    case 'HERO':
      return <HeroRenderer component={component} />;
    case 'PAGE_WRAPPER':
      return <PageWrapperRenderer component={component} onSubmit={onSubmit} onNavigate={onNavigate} isRecaptchaReady={isRecaptchaReady} isRecaptchaEnabled={isRecaptchaEnabled} isSlowNetwork={isSlowNetwork} />;
    case 'DEVICE_STATUS_CHECK':
      return <DeviceStatusCheckRenderer component={component} onSubmit={onSubmit} onNavigate={onNavigate} isRecaptchaReady={isRecaptchaReady} isRecaptchaEnabled={isRecaptchaEnabled} isSlowNetwork={isSlowNetwork} />;
    case 'FORM':
      return <DeviceStatusCheckRenderer component={component} onSubmit={onSubmit} onNavigate={onNavigate} isRecaptchaReady={isRecaptchaReady} isRecaptchaEnabled={isRecaptchaEnabled} isSlowNetwork={isSlowNetwork} />;
    case 'FAQ':
      return <FAQRenderer component={component} />;
    case 'DEVICE_STATUS':
      return <DeviceStatusRenderer component={component} onSubmit={onSubmit} onNavigate={onNavigate} isRecaptchaReady={isRecaptchaReady} isRecaptchaEnabled={isRecaptchaEnabled} isSlowNetwork={isSlowNetwork} />;
    case 'CONFIRMATION':
      return <ConfirmationRenderer component={component} onNavigate={onNavigate} />;
    case 'STATUS_DISPLAY':
      return <StatusDisplayRenderer component={component} onSubmit={onSubmit} onNavigate={onNavigate} isRecaptchaReady={isRecaptchaReady} isRecaptchaEnabled={isRecaptchaEnabled} isSlowNetwork={isSlowNetwork} />;
    default:
      console.warn(`Unknown component type: ${component.type} (normalized: ${componentType})`);
      return null;
  }
};

export default ComponentRenderer;